import request from '../../axios';
import {ICreateStoreOrderTransactionPayload} from './types';

const postPaymentStoreOrderTransaction = async (
  payload: ICreateStoreOrderTransactionPayload,
) => {
  const {data} = await request.post(
    `/api/v2/payment/payment-store-order-transaction`,
    payload,
  );
  return data;
};

export default postPaymentStoreOrderTransaction;
